/**
 * VOTE SYSTEM - Sistema de Votos
 * Maneja los votos disponibles del jugador
 */

import { ROUND_DEFAULTS } from '../utils/constants.js';

export default class VoteSystem {
  constructor(scene, initialVotes = ROUND_DEFAULTS.INITIAL_VOTES) {
    this.scene = scene;
    this.initial = initialVotes;
    this.current = initialVotes;
    this.used = 0;
  }

  /**
   * Obtener votos actuales
   * @returns {number}
   */
  getVotes() {
    return this.current;
  }

  /**
   * Obtener votos iniciales
   * @returns {number}
   */
  getInitial() {
    return this.initial;
  }

  /**
   * Obtener votos usados
   * @returns {number}
   */
  getUsed() {
    return this.used;
  }

  /**
   * Usar un voto
   * @returns {boolean} true si se pudo usar, false si no hay votos
   */
  useVote() {
    if (this.current <= 0) {
      return false;
    }

    this.current--;
    this.used++;
    this.onVoteUsed();
    return true;
  }

  /**
   * Verificar si hay votos disponibles
   * @returns {boolean}
   */
  hasVotesLeft() {
    return this.current > 0;
  }

  /**
   * Verificar si se han usado todos los votos
   * @returns {boolean}
   */
  allVotesUsed() {
    return this.current === 0;
  }

  /**
   * Obtener porcentaje de votos usados
   * @returns {number} 0-100
   */
  getUsagePercentage() {
    return (this.used / this.initial) * 100;
  }

  /**
   * Agregar votos (powerup, bonus, etc)
   * @param {number} amount
   */
  addVotes(amount) {
    this.current += amount;
    this.onVotesAdded(amount);
  }

  /**
   * Resetear votos
   * @param {number} newInitial - Nuevos votos iniciales (opcional)
   */
  reset(newInitial = null) {
    if (newInitial !== null) {
      this.initial = newInitial;
    }
    this.current = this.initial;
    this.used = 0;
    this.onVotesReset();
  }

  /**
   * Callback cuando se usa un voto
   */
  onVoteUsed() {
    this.scene.events.emit('voteUsed', {
      current: this.current,
      used: this.used
    });
  }

  /**
   * Callback cuando se agregan votos
   */
  onVotesAdded(amount) {
    this.scene.events.emit('votesAdded', {
      amount: amount,
      current: this.current
    });
  }

  /**
   * Callback cuando se resetean los votos
   */
  onVotesReset() {
    this.scene.events.emit('votesReset', {
      initial: this.initial,
      current: this.current
    });
  }

  /**
   * Destruir el sistema
   */
  destroy() {
    this.scene = null;
  }
}
